import { LoadingAndErrorRoot } from "./LoadingAndErrorWrapper.styled";
export default LoadingAndErrorRoot;
